export default __webpack_public_path__ + "static/media/pokeball.e45a6ab4.png";